import DailyDashboard from './DailyDashboard';

export default DailyDashboard;
